import React from 'react';
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import '../../../../static/styles/apiguide.scss';
import '../../../../static/styles/dashboard.scss';

export default class ViewTourProductHistory extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const col_number_8 = 8;
        const total_levels = 6;
        const level1 = 5;
        const level2 = 4;
        const level2_prefix = level1 - level2;
        const level3 = 3;
        const level3_prefix = level1 - level3;
        const level4 = 2;
        const level4_prefix = level1 - level4;
        const level5 = 1;
        const level5_prefix = level1 - level5;
        return (
            <div id={"view-tour-product-history"}>
                {/*<h3 className="mb0 mt40">3. 여행상품의 히스토리 가져오기</h3>*/}
                <h3 className="mb0 mt40">여행상품의 히스토리 가져오기</h3>

                <div className="blog-post-meta">
                                <span
                                    className="s-post">여행상품 id 로 해당 상품의 이력을 가져옵니다.</span>
                    <h3 className="request-method">
                        <span className="label label-primary">GET</span>
                    </h3>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <td>Path</td>
                            <td>Example Endpoint</td>
                        </tr>
                        <tr>
                            <td>/v1/marketplace/history/tours/{'{travelProductId}'}</td>
                            <td>
                                https://api-gateway.coupang.com/v2/providers/travel_connect_api/apis/v1/marketplace/history/tours/1234567890
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <h4>Request Parameters</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan="4" className="bold">Request Header</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>Request-Vendor-Id</td>
                            <td>O</td>
                            <td>String</td>
                            <td>벤더 아이디 요청</td>
                        </tr>
                        <tr>
                            <th colSpan="4" className="bold"> Path Segment Parameters</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Required</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td>travelProductId</td>
                            <td>O</td>
                            <td>Long</td>
                            <td>여행상품 ID</td>
                        </tr>
                        <tr>
                            <td>pageSize</td>
                            <td>X</td>
                            <td>String</td>
                            <td>페이지 사이즈</td>
                        </tr>
                        <tr>
                            <td>nextPageToken</td>
                            <td>X</td>
                            <td>String</td>
                            <td>다음 페이지 토큰, Default:50</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <h4>Response Specifications</h4>
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th colSpan={level1}>Name</th>
                            <th>Type</th>
                            <th>Description</th>
                        </tr>
                        <tr>
                            <td colSpan={level1}>code</td>
                            <td>String</td>
                            <td>응답 코드</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>message</td>
                            <td>String</td>
                            <td>응답 메세지</td>
                        </tr>
                        <tr>
                            <td colSpan={level1}>data</td>
                            <td>List{'<ChangeHistoryDto>'}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>targetId</td>
                            <td>String</td>
                            <td>프로덕트 아이디</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>type</td>
                            <td>String</td>
                            <td>유형</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>operation</td>
                            <td>String</td>
                            <td>처리</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>changedAt</td>
                            <td>String</td>
                            <td>수정 일시</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td colSpan={level2}>changedBy</td>
                            <td>String</td>
                            <td>수정자</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive mt40">
                    <div className="panel panel-default">
                        <div className="panel-heading">
                            <h3 className="panel-title"></h3>
                            <a data-toggle="collapse" href = "#historyResponse">Response Body Sample</a>
                        </div>
                        <div id="historyResponse" className = "panel-collapse collapse">
                            <div className="panel-body">
                    <pre className="ty01">
                        {`
{
    "code": 200,
    "message": "OK",
    "nextPageToken": "1573553941810",
    "size": 20,
    "data": [
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:41:17",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:41:11",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:41:08",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:41:06",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:41:05",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:41:03",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:41:01",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:40:59",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:40:58",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:21:07",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:21:05",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:21:03",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:21:00",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:20:59",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:20:02",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:20:00",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:19:58",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:19:56",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "UPDATE",
            "changedAt": "2019-11-12 19:19:55",
            "changedBy": "SYSTEM"
        },
        {
            "targetId": "511485064899461120",
            "type": "PRODUCT",
            "operation": "CREATE",
            "changedAt": "2019-11-12 19:19:01",
            "changedBy": "127.0.0.1"
        }
    ]
}
                        `}

                    </pre>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="table-responsive">
                    <table className="table table-striped">
                        <tbody>
                        <tr>
                            <th>HTTP CODE</th>
                            <th>message</th>
                            <th>설명</th>
                        </tr>
                        <tr>
                            <td>400</td>
                            <td>Bad request</td>
                            <td>요청 파라미터 값이 정확하지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>401</td>
                            <td>Unauthorized Error</td>
                            <td>잘못된 인증 정보</td>
                        </tr>
                        <tr>
                            <td>403</td>
                            <td>Forbidden Error</td>
                            <td>클라이언트 에서 인증을 제공하였으나 접속 허가를 받지 못했을 경우에 발생합니다.</td>
                        </tr>
                        <tr>
                            <td>410</td>
                            <td>The resource has been permanently deleted</td>
                            <td>리소스가 삭제되었을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>412</td>
                            <td>Precondition failed</td>
                            <td>전제조건이 충족하지 않아 요청이 처리되지 않을 경우에 발생합니다</td>
                        </tr>
                        <tr>
                            <td>429</td>
                            <td>Too many requests</td>
                            <td>요청이 많을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>504</td>
                            <td>API Gateway response timeout</td>
                            <td>API 게이트웨이 응답시간 초과할 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>521</td>
                            <td>API provider server has error</td>
                            <td>API 프로바이더 서버에 에러가 있을 경우 발생합니다</td>
                        </tr>
                        <tr>
                            <td>524</td>
                            <td>API provider to API gateway connection response timeout</td>
                            <td>API 프로바이더에서 API 게이트웨이 연결 응답 시간 초과할 경우 발생합니다</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/TourAPIContent/V1/ProductAPI/ViewTourProductHistory.jsx